import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import product from "./modules/product";
import game from "./modules/game";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  getters:{
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    product,
    game,
  }
})
